import { render } from "./autocomplete.vue?vue&type=template&id=74cd4206&scoped=true&ts=true"
import script from "./autocomplete.vue?vue&type=script&lang=ts"
export * from "./autocomplete.vue?vue&type=script&lang=ts"

import "./autocomplete.vue?vue&type=style&index=0&id=74cd4206&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74cd4206"]])

export default __exports__